import { render, staticRenderFns } from "./viewDoc.vue?vue&type=template&id=6c8a989a&scoped=true&"
import script from "./viewDoc.vue?vue&type=script&lang=js&"
export * from "./viewDoc.vue?vue&type=script&lang=js&"
import style0 from "./viewDoc.vue?vue&type=style&index=0&id=6c8a989a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a989a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VFlex,VLayout,VTextField})
